import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "ATR Short ID:", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Job Title:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Doctype:", -1);
const _hoisted_15 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_16 = {
    key: 0,
    class: "flex justify-end"
};
const _hoisted_17 = { class: "lg:hidden" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_activity_feed = _resolveComponent("activity-feed");
    const _component_approval_steps = _resolveComponent("approval-steps");
    const _component_form_layout = _resolveComponent("form-layout");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_form_layout, {
            "nav-item-config": !_ctx.formData.formOne.saved ? [_ctx.navItemConfig[0]] : _ctx.navItemConfig,
            "current-nav-item": _ctx.currentNavItem,
            "form-point": _ctx.formPoint,
            "form-data": _ctx.formData,
            "hide-action": _ctx.hideAction && !_ctx.currentUserIsAssigned,
            "display-header": _ctx.showApprovalSteps || _ctx.editable,
            "display-timeline": _ctx.showApprovalSteps || _ctx.editable,
            "display-footer": _ctx.showApprovalSteps || _ctx.editable,
            onSetCurrentNavItem: _ctx.setCurrentNavItem
        }, {
            pageTitle: _withCtx(() => [
                _createTextVNode("Approval to Recruit (ATR)")
            ]),
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_3, _toDisplayString(_ctx.formData.shortId), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.formData.formThree.jobTitle || "-"), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.findStage(_ctx.formData.currentStageName, _ctx.formData.status)), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.formData.formOne?.hiringManagerEmail ??
                        _ctx.formData.currentAssigneeEmail), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_15, _toDisplayString(_ctx.formData.docType), 1)
                ]),
                _createTextVNode(),
                (_ctx.profile?.ADMIN || _ctx.profile?.H2R || _ctx.profile?.RESOURCING)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("button", {
                            class: "text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.handleReassign && _ctx.handleReassign(...args)), ["prevent"]))
                        }, "\n          Re-assign\n        ")
                    ]))
                    : _createCommentVNode("", true)
            ]),
            navFooter: _withCtx(() => [
                (_ctx.currentUserIsAssigned &&
                    !_ctx.editable &&
                    ['starter.notifyHROps', 'starter.notifyBudgetApprover'].includes(_ctx.formData.currentStageName))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["w-full text-center px-4 py-2 mb-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat", { 'bg-red-700 border-red-900': _ctx.editable }]),
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.handleMakeEditable && _ctx.handleMakeEditable(...args)))
                    }, "\n        Edit\n      ", 2))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned && !_ctx.hideAction)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.openApprovalModal && _ctx.openApprovalModal(...args)))
                    }, _toDisplayString(_ctx.editable ? "Save Edits" : "Action"), 1))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.currentStageName === 'DRAFT')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showDeleteModal = true))
                    }, "\n        Delete Draft\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData.currentStageName &&
                    _ctx.formData.currentStageName !== 'DRAFT' &&
                    (_ctx.profile?.ADMIN ||
                        _ctx.profile?.H2R ||
                        _ctx.profile?.RESOURCING ||
                        _ctx.currentUserIsAssigned)
                    && !_ctx.hideCancel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCancelStarter && _ctx.handleCancelStarter(...args)))
                    }, "\n        Cancel Starter\n      "))
                    : _createCommentVNode("", true)
            ]),
            navFooterWithCancel: _withCtx(() => [
                (_ctx.formData.currentStageName &&
                    _ctx.formData.currentStageName !== 'DRAFT' &&
                    (_ctx.profile?.ADMIN ||
                        _ctx.profile?.H2R ||
                        _ctx.profile?.RESOURCING ||
                        _ctx.currentUserIsAssigned)
                    && !_ctx.hideCancel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCancelStarter && _ctx.handleCancelStarter(...args)))
                    }, "\n        Cancel Starter\n      "))
                    : _createCommentVNode("", true)
            ]),
            main: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentNavItem.component), {
                    "atr-ready-to-submit": _ctx.atrReadyToSubmit,
                    "config-data": _ctx.configData,
                    "form-data": _ctx.formData[_ctx.currentNavItem.name],
                    data: _ctx.formData,
                    "disable-form": _ctx.showApprovalSteps,
                    "show-approval-steps": _ctx.showApprovalSteps,
                    status: _ctx.formData.status,
                    editable: true,
                    "onUpdate:formData": _ctx.handleUpdateFormData,
                    "onUpdate:reset": _ctx.handleResetFormData,
                    onSubmitForm: _ctx.handleSubmitForm,
                    onSubmitAtr: _ctx.handleSubmitAtr
                }, null, 40, ["atr-ready-to-submit", "config-data", "form-data", "data", "disable-form", "show-approval-steps", "status", "onUpdate:formData", "onUpdate:reset", "onSubmitForm", "onSubmitAtr"])),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, [
                    (_ctx.currentUserIsAssigned &&
                        !_ctx.editable &&
                        ['starter.notifyHROps', 'starter.notifyBudgetApprover'].includes(_ctx.formData.currentStageName))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["w-full text-center px-4 py-2 mb-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat", { 'bg-red-700 border-red-900': _ctx.editable }]),
                            onClick: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_ctx.handleMakeEditable && _ctx.handleMakeEditable(...args)))
                        }, "\n          Edit\n        ", 2))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.currentUserIsAssigned && !_ctx.hideAction)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_ctx.openApprovalModal && _ctx.openApprovalModal(...args)))
                        }, _toDisplayString(_ctx.editable ? "Save Edits" : "Action"), 1))
                        : _createCommentVNode("", true)
                ])
            ]),
            timeline: _withCtx(() => [
                (_ctx.formData.activityList)
                    ? (_openBlock(), _createBlock(_component_activity_feed, {
                        key: 0,
                        "activity-list": _ctx.formData?.activityList
                    }, null, 8, ["activity-list"]))
                    : _createCommentVNode("", true)
            ]),
            footer: _withCtx(() => [
                (_ctx.formData.shortId)
                    ? (_openBlock(), _createBlock(_component_approval_steps, {
                        key: 0,
                        "form-data": _ctx.formData,
                        "doc-type": "STARTER",
                        onComment: _cache[8] || (_cache[8] = ($event) => (_ctx.fetchSingleAtr(_ctx.formData.docId)))
                    }, null, 8, ["form-data"]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["nav-item-config", "current-nav-item", "form-point", "form-data", "hide-action", "display-header", "display-timeline", "display-footer", "onSetCurrentNavItem"]),
        _createTextVNode(),
        (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 0,
                onClose: _ctx.handleModalClose
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("ATR Approval")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("What would you like to do with this ATR?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[9] || (_cache[9] =
                            //@ts-ignore
                            (...args) => (_ctx.handleApproveAtr && _ctx.handleApproveAtr(...args)))
                    }, "\n        Approve\n      "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[10] || (_cache[10] =
                            //@ts-ignore
                            (...args) => (_ctx.handleRejectAtr && _ctx.handleRejectAtr(...args)))
                    }, "\n        Reject\n      ")
                ]),
                _: 1
            }, 8, ["onClose"]))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.showDeleteModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 1,
                onClose: _cache[13] || (_cache[13] = ($event) => (_ctx.showDeleteModal = false))
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Delete Draft")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("Are you sure you want to delete this draft?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[11] || (_cache[11] =
                            //@ts-ignore
                            (...args) => (_ctx.handleDeleteDraft && _ctx.handleDeleteDraft(...args)))
                    }, "\n        Delete\n      "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.showDeleteModal = false))
                    }, "\n        Cancel\n      ")
                ]),
                _: 1
            }))
            : _createCommentVNode("", true)
    ], 64));
}
